"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQueryParameters = exports.getDateBeforeMonths = exports.diffInDays = exports.sanatizeString = exports.decrypt = exports.encrypt = void 0;
exports.IDSource = IDSource;
exports.generateUnique4DigitID = generateUnique4DigitID;
exports.computeEventsStatus = computeEventsStatus;
exports.getOverlappingEvent = getOverlappingEvent;
const differenceInDays_1 = require("date-fns/differenceInDays");
const isAfter_1 = require("date-fns/isAfter");
const isBefore_1 = require("date-fns/isBefore");
const isSameDay_1 = require("date-fns/isSameDay");
const isWithinInterval_1 = require("date-fns/isWithinInterval");
const startOfDay_1 = require("date-fns/startOfDay");
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../../types");
let Cryptr = require("cryptr");
const cryptr = new Cryptr("OptimetriksExtraSecretKey");
/**
 * @deprecated
 */
const encrypt = (value) => cryptr.encrypt(value);
exports.encrypt = encrypt;
/**
 * @deprecated
 */
const decrypt = (value) => cryptr.decrypt(value);
exports.decrypt = decrypt;
let currentMsIndex = 0;
let lastTimestamp = 0;
const chars = "abcdefghijklmnopqrstuvwxyz";
/**
 * generate IDs
 * @return {string}
 */
function IDSource() {
    let currentTimestamp = Date.now();
    if (currentTimestamp !== lastTimestamp) {
        currentMsIndex = 1e6 + Math.floor(Math.random() * 100000);
        lastTimestamp = currentTimestamp;
    }
    currentMsIndex += 111;
    let id1 = currentTimestamp.toString(36) + currentMsIndex.toString(36);
    let id2 = id1.split("").reverse().join("");
    let prefix = "";
    for (let i = 0; i < 4; i++) {
        prefix += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return prefix + id2;
}
function generateUnique4DigitID() {
    let currentTimestamp = Date.now();
    // Reset currentMsIndex if the timestamp has changed
    if (currentTimestamp !== lastTimestamp) {
        currentMsIndex = 1e6 + Math.floor(Math.random() * 100000);
        lastTimestamp = currentTimestamp;
    }
    currentMsIndex += 111;
    let id = currentTimestamp.toString(36) + currentMsIndex.toString(36);
    id = id.split("").reverse().join("");
    // Ensure id length is at least 4 characters
    while (id.length < 4) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // Extract first 4 characters from id
    return id.substring(0, 4);
}
const sanatizeString = (str) => {
    return str
        ? str
            .split("''")
            .map((s) => s.split("'").join("''"))
            .join("''")
        : "";
};
exports.sanatizeString = sanatizeString;
const diffInDays = (date1, date2, useStartOfDay = true) => {
    if (useStartOfDay) {
        return (0, differenceInDays_1.differenceInDays)((0, startOfDay_1.startOfDay)(date2), (0, startOfDay_1.startOfDay)(date1));
    }
    else {
        return (0, differenceInDays_1.differenceInDays)(date2, date1);
    }
};
exports.diffInDays = diffInDays;
function computeEventsStatus(events) {
    const today = (0, startOfDay_1.startOfDay)(new Date());
    return events.map((event) => {
        const eventEndDay = (0, startOfDay_1.startOfDay)(new Date(event.end_time));
        if ((0, isBefore_1.isBefore)(eventEndDay, today) &&
            [types_1.CalendarEventStatus.PLANNED, undefined].includes(event.status)) {
            event.status = types_1.CalendarEventStatus.OUTDATED;
        }
        if (((0, isSameDay_1.isSameDay)(eventEndDay, today) || (0, isAfter_1.isAfter)(eventEndDay, today)) &&
            [types_1.CalendarEventStatus.OUTDATED, undefined].includes(event.status)) {
            event.status = types_1.CalendarEventStatus.PLANNED;
        }
        return event;
    });
}
function getOverlappingEvent(events, newEvent) {
    const newEventStart = new Date(newEvent.start_time);
    const newEventEnd = new Date(newEvent.end_time);
    return events.find((event) => {
        const eventStart = new Date(event.start_time);
        const eventEnd = new Date(event.end_time);
        return ((0, isWithinInterval_1.isWithinInterval)(newEventStart, { start: eventStart, end: eventEnd }) ||
            (0, isWithinInterval_1.isWithinInterval)(newEventEnd, { start: eventStart, end: eventEnd }));
    });
}
const getDateBeforeMonths = (months, date = new Date()) => {
    date.setMonth(date.getMonth() - months);
    return date;
};
exports.getDateBeforeMonths = getDateBeforeMonths;
const addQueryParameters = (endpoint, params) => {
    const parameters = lodash_1.default.omitBy(params, lodash_1.default.isNil); // remove all undefined properties
    if (!parameters) {
        return endpoint;
    }
    let formattedQuery = [];
    for (const key of Object.keys(parameters)) {
        const parameterValue = parameters[key];
        if (Array.isArray(parameterValue)) {
            formattedQuery.push(`${key}=[${parameterValue.join(",")}]`);
        }
        else if (lodash_1.default.isObject(parameterValue)) {
            formattedQuery.push(`${key}=${JSON.stringify(parameterValue)}`);
        }
        else {
            formattedQuery.push(`${key}=${parameterValue}`);
        }
    }
    if (formattedQuery.length > 0) {
        return `${endpoint}?${formattedQuery.join("&")}`;
    }
    else {
        return endpoint;
    }
};
exports.addQueryParameters = addQueryParameters;
